const state = {
  viewObject: null,
  allViews: null,
  newViewRender: true,
  isViewChanged: false,
}

const getters = {
  getViewObject: state => state.viewObject,
  getAllViews: state => state.allViews,
  getNewViewRender: state => state.newViewRender,
  getIsViewChanged: state => state.isViewChanged,
}

const mutations = {
  setViewObject (state, viewObject) {
    state.viewObject = viewObject
  },
  setAllViews (state, allViews) {
    state.allViews = allViews
  },
  setNewViewRender (state, render) {
    state.newViewRender = render
  },
  setIsViewChanged (state, isViewChanged) {
    state.isViewChanged = isViewChanged
  },
  removeViews (state) {
    for (const key in state) {
      state[key] = null
    }
  },
}

const actions = {
  setViewObject ({ commit }, viewObject) {
    commit('setViewObject', viewObject)
  },
  setAllViews ({ commit }, allViews) {
    commit('setAllViews', allViews)
  },
  setNewViewRender ({ commit }, render) {
    commit('setNewViewRender', render)
  },
  setIsViewChanged ({ commit }, isViewChanged) {
    commit('setIsViewChanged', isViewChanged)
  },
  removeAllViews ({ commit }) {
    commit('removeViews')
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
}
